import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { getGroupsByGame } from './dashboardSlice';
import QRCode from './qr';

function Dashboard() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const groups = useSelector((state) => state.dashboard.groups);
  const cookieGameId = Cookies.get("game_id");
  const cookieGameCode = Cookies.get("game_code");

  const [gameCode, setGameCode] = useState(0);
  const [gameCodeArray, setGameCodeArray] = useState([]);

  const host = window.location.host;

  useEffect(() => {
    setGameCode(cookieGameCode);

    dispatch(getGroupsByGame(cookieGameId));

    const interval = setInterval(() => {
      dispatch(getGroupsByGame(cookieGameId));
    }, 5000);

    return () => clearInterval(interval);

  }, []);

  useEffect(() => {
    setGameCodeArray(String(gameCode).split(''));
  }, [gameCode]);

  useEffect(() => {
    let playerCount = 0;
    let joinedCount = 0;

    groups.forEach(group => {
      group.players.forEach(player => {
        playerCount++;
        if (player.status === 'username_created' || player.status === 'joined' || player.status === 'confirmed') {
          joinedCount++;
        }
      });
    });
    if (playerCount !== 0 && joinedCount === playerCount) {
      navigate(`/app/digiboard/scoreBoard/${cookieGameId}${window.location.search}`);
    }
  }, [groups]);

  return (
    <div className="dashboard-container qr-screen">
      <div className='qr-section'><QRCode /></div>
      <div className='instructions-section'>
        <div className='title'>
          <h1>{t("digiboard.onboard.title")}</h1>
        </div>
        <div className='sub-title'>
          <h2>{t("digiboard.onboard.code_title")}</h2>
        </div>
        <div className='instructions'>
          <p>{t("digiboard.onboard.code_text")}</p>
          <div className='url-container'>
            {host}/app/game
          </div>
          <div className='horizontal-ornament'></div>
          <p>{t("digiboard.onboard.code_text_2")}</p>
          <div className='code-container'>
            {gameCodeArray.length === 4 && (
              <>
                {gameCodeArray.map((item, index) => (
                  <div key={index} className='digid'><div className='number'>{item}</div></div>
                ))}
              </>
            )}
          </div>
        </div>
        <div className='scroll-end'></div>
      </div>
    </div>
  )
}

export default Dashboard;